import {
  SEARCH_HISTORY_SEPARATOR,
  SEARCH_HISTORY_STORAGE_KEY,
} from './constants';
import { decodeSeparator } from './utils/decodeSeparator';
import { isLocalStorageAvailable } from './utils/localStorage';

export const getSearchHistory = (maxLength?: number): string[] => {
  if (isLocalStorageAvailable()) {
    const storage = localStorage.getItem(SEARCH_HISTORY_STORAGE_KEY);

    if (storage) {
      return storage
        .split(SEARCH_HISTORY_SEPARATOR)
        .slice(0, maxLength || storage.length)
        .map((query) => decodeSeparator(query));
    }
  }
  return [];
};
